import { Link as RouterLink, LinkProps } from 'react-router-dom'

const sizes = {
  large: 'large-underline',
  base: 'base-underline',
  small: 'small-underline',
  tiny: 'tiny-underline',
}
interface Props extends LinkProps {
  size?: keyof typeof sizes
}

const Link = ({ className, size = 'base', children, ...props }: Props) => {
  const classNames = [sizes[size], className]
  return (
    <RouterLink className={classNames.join(' ')} {...props}>
      {children}
    </RouterLink>
  )
}

export default Link
